import { load } from 'recaptcha-v3'
import config from '@/config'

class RecaptchaService {
  init() {
    this.recaptchaPromise = load(config.recaptchaKey, { autoHideBadge: true })
  }

  async getToken(action) {
    const recaptcha = await this.recaptchaPromise
    return recaptcha.execute(action)
  }
}

export default new RecaptchaService()
